function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Rest from './Rest';
import Graph from './Graph';
import { useCustomField } from '../../../../common/hooks/useCustomField';
import classNames from 'classnames';
export * from './Graph';
export * from './Rest';

const Async = ({
  loadOptions,
  name,
  value,
  onChange,
  disabled,
  multiple,
  creatable,
  isValid,
  isInvalid,
  ...props
}) => {
  const [customField, setCustomField] = useCustomField({
    name,
    value,
    onChange,
    multiple
  });
  const [options, setOptions] = useState(Array.isArray(props.defaultOptions) ? props.defaultOptions : []);

  const handleChange = data => {
    setOptions(Array.isArray(data) ? data : [data]);
    const value = Array.isArray(data) ? data.map(item => item.value) : data ? data.value : '';
    setCustomField(prev => ({ ...prev,
      value,
      dirty: true
    }));
  };

  const final = customField.value && (Array.isArray(customField.value) ? options.filter(item => customField.value.includes(item.value)) : options.find(item => item.value === customField.value));
  const Component = creatable ? AsyncCreatableSelect : AsyncSelect;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classNames('auto-complete-select', {
      'is-valid': isValid,
      'is-invalid': isInvalid
    }),
    value: final,
    cacheOptions: true,
    defaultOptions: true,
    isClearable: true,
    isMulti: multiple,
    isDisabled: disabled,
    onChange: handleChange
  }, props, {
    loadOptions: loadOptions
  }));
};

Async.Rest = Rest;
Async.Graph = Graph;
export default Async;